import {
  CAR_DATA_MASTER_GET_VERSIONS_BEGIN,
  CAR_DATA_MASTER_GET_VERSIONS_SUCCESS,
  CAR_DATA_MASTER_GET_VERSIONS_FAILURE,
  CAR_DATA_MASTER_GET_VERSIONS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getVersions(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_VERSIONS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM + "/abms/version" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            const versions = res.data.data;
            if (versions.length > 0) {
              versions.forEach((version) => {
                version['brand_name'] = version?.Model?.Brand?.name;
                version['model_name'] = version?.Model?.name;
                version['canDelete'] = true;
                version['files'] = {};
              });
              dispatch({
                type: CAR_DATA_MASTER_GET_VERSIONS_SUCCESS,
                data: versions,
                pagination: res.data.pagination
              });
              resolve(res);
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_VERSIONS_SUCCESS,
                data: [],
                pagination: res.data.pagination
              });
              resolve(res);
            }

          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_VERSIONS_FAILURE,
              data: []
            });
            reject();
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CAR_DATA_MASTER_GET_VERSIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetVersionsError() {
  return {
    type: CAR_DATA_MASTER_GET_VERSIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_VERSIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getVersionsPending: true,
        getVersionsError: null,
      };

    case CAR_DATA_MASTER_GET_VERSIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        getVersionsPending: false,
        getVersionsError: null,
        versionListOrigin: [...action.data],
        versionList: [...action.data],
        versionsPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_VERSIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        getVersionsPending: false,
        getVersionsError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_VERSIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getVersionsError: null,
      };

    default:
      return state;
  }
}
